/**
 * Paleta de gráficos validada (checagens de banda de luminosidade, croma,
 * separação para daltonismo e contraste) nos dois temas.
 *
 * Regras que o restante do código respeita:
 * - as cores são atribuídas por ORDEM FIXA de série, nunca cicladas;
 * - a partir de 2 séries sempre existe legenda (identidade nunca é só cor);
 * - nunca há dois eixos Y no mesmo gráfico.
 */

export const SERIES_LIGHT = [
  '#2a78d6', // azul
  '#eb6834', // laranja
  '#1baf7a', // água
  '#eda100', // amarelo
  '#e87ba4', // magenta
  '#008300', // verde
  '#4a3aa7', // violeta
  '#e34948', // vermelho
] as const;

export const SERIES_DARK = [
  '#3987e5',
  '#d95926',
  '#199e70',
  '#c98500',
  '#d55181',
  '#008300',
  '#9085e9',
  '#e66767',
] as const;

/** Rampa ordinal (etapas de funil / faixas ordenadas), do claro ao escuro. */
export const ORDINAL_LIGHT = ['#86b6ef', '#5598e7', '#3987e5', '#256abf', '#1c5cab', '#184f95', '#104281'];
export const ORDINAL_DARK = ['#cde2fb', '#9ec5f4', '#6da7ec', '#3987e5', '#256abf', '#1c5cab', '#184f95'];

export const STATUS_COLORS = {
  good: { light: '#008300', dark: '#3fae67' },
  warning: { light: '#eda100', dark: '#c98500' },
  critical: { light: '#e34948', dark: '#e66767' },
} as const;

export interface ChartTheme {
  series: readonly string[];
  ordinal: string[];
  grid: string;
  axis: string;
  text: string;
  surface: string;
  tooltipBg: string;
  tooltipBorder: string;
}

export function chartTheme(isDark: boolean): ChartTheme {
  return isDark
    ? {
        series: SERIES_DARK,
        ordinal: ORDINAL_DARK,
        grid: '#283244',
        axis: '#3a465c',
        text: '#94a3b8',
        surface: '#111621',
        tooltipBg: '#181f2c',
        tooltipBorder: '#283244',
      }
    : {
        series: SERIES_LIGHT,
        ordinal: ORDINAL_LIGHT,
        grid: '#e9edf3',
        axis: '#cbd5e1',
        text: '#64748b',
        surface: '#ffffff',
        tooltipBg: '#ffffff',
        tooltipBorder: '#e2e8f0',
      };
}

/** Cor da série pelo índice — sem ciclagem: acima do 8º volte para "Outros". */
export function seriesColor(theme: ChartTheme, index: number): string {
  return theme.series[Math.min(index, theme.series.length - 1)];
}
